import React from 'react';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { BannerWithButton } from 'Components/frameworks/banner-with-button/BannerWithButton';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';
import { Notification } from 'Components/frameworks/notification/Notification';
import { t } from 'Src/i18n';
import { OptionModal } from 'Views/booking/summary/option-modal/OptionModal';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
type OptionBlockProps = {
  showOptionButton: boolean;
  onOptionTaking: () => Promise<any>;
  onOptionButtonClick: () => void;
  onOptionModalClose: () => void;
  duration: any;
  isBookingAlreadyExistsErrorMessageOpen: boolean;
  proposalId: string;
  resortImage: string;
  isOptionAllowed: boolean;
  toggleOptionModal: boolean;
  disclaimer: string;
  durationDisclaimer: boolean;
};

const OptionBlock = ({
  showOptionButton,
  onOptionTaking,
  duration,
  isBookingAlreadyExistsErrorMessageOpen,
  proposalId,
  resortImage,
  isOptionAllowed,
  onOptionButtonClick,
  onOptionModalClose,
  toggleOptionModal,
  disclaimer = '',
  durationDisclaimer,
}: OptionBlockProps) => {
  const { trackClickEvent } = useTrackEvent();

  const onOptionModalButtonClick = () => {
    onOptionTaking();
    onOptionModalClose();
    trackClickEvent(TRACK_EVENT_NAMES.CLICK_SUMMARY, {
      detail_click: 'hold_option_validate',
    });
  };

  return (
    <React.Fragment>
      <div className="mx-auto mb-20 max-w-site-medium" data-testid="bloc-option" id="bloc-option">
        {showOptionButton && (
          <BannerWithButton
            bannerPadding="px-20 pt-20"
            bannerTitle={t('booking.option.title')}
            ctaText={t('booking.option.buttonLabel')}
            ctaAction={onOptionButtonClick}
            iconName={ICONS.CALENDAR_OPTION}
            iconColor={COLORS.SIENNA}
            iconWidth="1.875rem"
            middleTextDesc={<p className="text-16 font-bold">{t('booking.option.subLabel2')}</p>}
            rightTextDesc={
              <div className="flex flex-col">
                {`${t('booking.option.description')}`}
                {duration && (
                  <div>
                    {!durationDisclaimer && (
                      <p data-testid="optionEndDate">{t('booking.option.DurationDisclaimer')}</p>
                    )}
                    <p className="font-bold">
                      {t('booking.summary.optionDuration', {
                        duration,
                      })}
                    </p>
                  </div>
                )}
              </div>
            }
            dataTestId="option-block"
          />
        )}
        {isBookingAlreadyExistsErrorMessageOpen && (
          <Notification className="bg-transparent text-red" iconName={ICONS.WARNING}>
            <p className="m-0 font-sans text-14 leading-normal text-red">
              {t('booking.cxo.warning.bookingExists')}
            </p>
          </Notification>
        )}
      </div>

      {toggleOptionModal && (
        <OptionModal
          onClose={onOptionModalClose}
          imageUrl={resortImage}
          onClick={onOptionModalButtonClick}
          proposalId={proposalId}
          isOptionAllowed={isOptionAllowed}
          optionDuration={duration}
          disclaimer={disclaimer}
        />
      )}
    </React.Fragment>
  );
};

export default OptionBlock;
